module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_07-a4e1d4d453f8437016c8e3ff065d36c5.png";